import { render, staticRenderFns } from "./StructureTreeNode.vue?vue&type=template&id=9bb8ced6&scoped=true&"
import script from "./StructureTreeNode.vue?vue&type=script&lang=ts&"
export * from "./StructureTreeNode.vue?vue&type=script&lang=ts&"
import style0 from "./StructureTreeNode.vue?vue&type=style&index=0&id=9bb8ced6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb8ced6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
